export default "__VITE_ASSET__2e7baf33__"